"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/CKFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_47)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_47`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 -0.000244141H30V23.9998H-6V-0.000244141Z",
					fill: "#01237A"
				}),
				/* @__PURE__ */ n("path", {
					d: "M20.9474 5.00846L21.3181 6.14909H22.5173L21.5471 6.854L21.9177 7.99463L20.9474 7.28958L19.9772 7.99463L20.3477 6.854L19.3775 6.14909H20.5768L20.9474 5.00846ZM16.0204 7.04923L17.0891 7.59365L17.9371 6.74572L17.7495 7.93021L18.818 8.4747L17.6335 8.66228L17.4459 9.84684L16.9013 8.77828L15.7169 8.96586L16.5651 8.11786L16.0204 7.04923ZM13.9796 11.9762L15.1203 11.6056L15.1203 10.4064L15.8252 11.3765L16.9658 11.0059L16.2608 11.9762L16.9658 12.9464L15.8252 12.5759L15.1203 13.5461V12.3468L13.9796 11.9762ZM16.0204 16.9031L16.5649 15.8344L15.7169 14.9864L16.9015 15.1741L17.4459 14.1055L17.6335 15.29L18.818 15.4775L17.7495 16.022L17.9371 17.2067L17.0891 16.3585L16.0204 16.9031ZM20.9474 18.9438L20.5768 17.8033H19.3774L20.3477 17.0984L19.9772 15.9577L20.9474 16.6626L21.9177 15.9577L21.5471 17.0984L22.5173 17.8033H21.3181L20.9474 18.9438ZM25.8743 16.9031L24.8056 16.3587L23.9577 17.2067L24.1453 16.022L23.0767 15.4777L24.2612 15.29L24.4489 14.1055L24.9932 15.1741L26.1778 14.9864L25.3297 15.8345L25.8743 16.9031ZM27.9151 11.9762L26.7745 12.3468V13.5461L26.0695 12.5758L24.9289 12.9464L25.6339 11.9762L24.9289 11.0059L26.0695 11.3765L26.7745 10.4064V11.6056L27.9151 11.9762ZM25.8743 7.04937L25.33 8.11786L26.1778 8.96586L24.9932 8.77828L24.4489 9.84684L24.2612 8.66228L23.0767 8.47456L24.1453 7.93021L23.9577 6.74579L24.8057 7.59365L25.8743 7.04937ZM-6 7.11091V8.23372H-2.76709L-6 10.3889V10.918L-1.97354 8.23365H-0.385965L-6 11.9764H1.85965V7.11084L-6 7.11091ZM0.736842 11.9762H-4.41207L0.736842 8.54376V11.9762ZM6.35088 3.74249L11.9649 -0.000244141H4.10526V4.8653H11.9649V3.74249H8.732L11.9649 1.58712V1.05807L7.93846 3.74235H6.35088V3.74249ZM5.22807 -0.000103867H10.377L5.22807 3.43239V-0.000103867ZM4.10526 11.9764H11.9649L6.35088 8.23365H7.93846L11.9649 10.9181V10.389L8.732 8.23372H11.9649V7.11091H4.10526V11.9764ZM5.22807 8.54376L10.377 11.9762H5.22807V8.54376ZM1.85965 -0.000244141H-6L-0.385965 3.74249H-1.97354L-6 1.05814V1.58719L-2.76709 3.74242H-6V4.86523H1.85965V-0.000244141ZM0.736842 3.43239L-4.41207 -0.000103867H0.736842V3.43239Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M4.10526 -0.000244141H1.85965V4.8653H-6V7.11091H1.85965V11.9764H4.10526V7.11091H11.9649V4.8653H4.10526V-0.000244141Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-0.385965 3.74249L-6 -0.000244141V1.05814L-1.97354 3.74249H-0.385965ZM6.35088 3.74249H7.93846L11.9649 1.05814V-0.000244141L6.35088 3.74249ZM-1.97354 8.23372L-6 10.9181V11.9764L-0.385965 8.23372H-1.97354ZM6.35088 8.23372L11.9649 11.9764V10.9181L7.93846 8.23372H6.35088Z",
					fill: "#D80027"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_47`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as CKFlag };
